import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressMarketAimApiBiEventsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/app-instance-manager-webapp',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/apps',
        destPath: '',
      },
    ],
    'wixapis.com': [
      {
        srcPath: '/apps',
        destPath: '',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
      {
        srcPath: '/api/v1/instance',
        destPath: '/v1/instance',
      },
      {
        srcPath: '/api/v1/scripts',
        destPath: '/v1/scripts',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/devcenter/app-instance/v1/instance',
        destPath: '/v1/instance',
      },
      {
        srcPath: '/devcenter/checkout/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/devcenter/checkout/v1/metered-billing-charges',
        destPath: '/v1/metered-billing-charges',
      },
      {
        srcPath: '/devcenter/scripts/v1/scripts',
        destPath: '/v1/scripts',
      },
      {
        srcPath: '/market/aim/v1/billing-event',
        destPath: '/v1/billing-event',
      },
      {
        srcPath: '/devcenter/bi-events/v1/bi-event',
        destPath: '/v1/bi-event',
      },
    ],
    _: [
      {
        srcPath: '/devcenter/app-instance/v1/instance',
        destPath: '/v1/instance',
      },
      {
        srcPath: '/devcenter/checkout/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/devcenter/checkout/v1/metered-billing-charges',
        destPath: '/v1/metered-billing-charges',
      },
      {
        srcPath: '/devcenter/scripts/v1/scripts',
        destPath: '/v1/scripts',
      },
      {
        srcPath: '/market/aim/v1/billing-event',
        destPath: '/v1/billing-event',
      },
      {
        srcPath: '/devcenter/bi-events/v1/bi-event',
        destPath: '/v1/bi-event',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_app-management_bi-events';

/** Submit a BI event to Wix. */
export function sendBiEvent(payload: object): RequestOptionsFactory<any> {
  function __sendBiEvent({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.devcenter.bi_events.v1.send_bi_event_response',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.market.aim.api.BIEventsService.sendBIEvent',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMarketAimApiBiEventsServiceUrl({
        protoPath: '/v1/bi-event',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __sendBiEvent;
}
